import React from "react";
import JsonData from "../data/data.json";

const phone = JsonData.Contact.phone;
const telHref = `tel:${String(phone).replace(/[^+\d]/g, "")}`;

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-12 intro-text">
                {/* Die h1 ist die stärkste Überschrift der Seite und nennt
                    die Leistung, nicht den Slogan – der steht als Unterzeile
                    darunter. */}
                <h1>{props.data ? props.data.title : "Loading"}</h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a href="#about" className="btn btn-lg page-scroll btn-custom">
                  Mehr Erfahren
                </a>{" "}
                <a href={telHref} className="btn btn-lg btn-custom">
                  <i className="fa fa-phone" aria-hidden="true"></i>
                  {` ${phone}`}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
